import { InfoWrapper } from 'app/components';
import styles from '../CreateNotificationModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Input } from 'app/components';

import { PortCatalogData } from 'ais-facade-api/api';
import { NotificationRuleSettingsT } from 'app/types/types';
import { PortInField } from 'app/components/FilterPanel/PortInField';
import { useEffect, useState } from 'react';
import { VesselField } from 'app/components/FilterPanel/VesselField';

export const RuleForAPort = ({
  errors,
  onPortChange,
  isAnyCheckedState,
  isSuccess,
}: NotificationRuleSettingsT<PortCatalogData>) => {
  const { t } = useTranslation();
  const [isAnyChecked, setIsAnyChecked] = isAnyCheckedState;

  const [searchState, setSearchState] = useState<any>({
    term: {
      port: '',
    },
    visibility: {
      area: false,
    },
  });

  return (
    <div className={styles.row}>
      <InfoWrapper
        label={t('Port')}
        value={
          <div className={styles.row_item}>
            <PortInField fieldName="port" searchState={[searchState, setSearchState]} onSelect={onPortChange} />

            {errors.port && <div className={styles.error_message}>{t(errors.port)}</div>}
          </div>
        }
      />
      <div className={styles.row_title}> {t('Vessel')}:</div>
      <Input
        label={t('AnyVessel')}
        name="mmsi"
        type="radio"
        value=""
        onChange={() => setIsAnyChecked(true)}
        checked={isAnyChecked}
      />
      <InfoWrapper
        label={
          <Input
            label={t('ChosenVessel')}
            name="mmsi"
            type="radio"
            value=""
            onChange={() => setIsAnyChecked(false)}
            checked={!isAnyChecked}
          />
        }
        value={
          <div className={styles.row_item}>
            <VesselField fieldName={'mmsi'} onSelect={onPortChange} />
            {!isAnyChecked && errors.mmsi && <div className={styles.error_message}>{t(errors.mmsi)}</div>}
          </div>
        }
      />
    </div>
  );
};
